module.exports = __webpack_public_path__ + "static/ctg-f644e2a374ae8528e28c442bd78791d4.jpg";